module.exports = __webpack_public_path__ + "static/media/trash.7b2bc3c9.svg";